import { gql } from "@apollo/client";
import { onAdyenPaymentSubmitError } from "../../types/FrontEnd/Adyen";

export interface AprivaPaymentResponse {
  name: string;
  success: boolean;
  data: {
    timestamp: string;
    amount: number;
    uniqueRequestId: string;
    authCode: string;
    responseCode: string;
    responseText: string;
    captured: boolean;
    description: string;
  };
}

export interface startMachineWithAnonStudentCardPayloadProps {
  roomId: string;
  locationId: string;
  as400Number: string;
  licensePlate: string;
  amount: number;
  currency: "usd";
  additionalBlocks: number | undefined;
  comment?: string;
  studentCardId: string;
  fullName: string;
}

export interface AprivaPayload {
  body: startMachineWithAnonStudentCardPayloadProps;
}

export interface AprivaPaymentData {
  data: AprivaPaymentResponse;
}

export interface AprivaErrorResponse {
  id: string;
  ts: string;
  name: string;
  success: boolean;
  errors: Array<{
    code: number;
    message: string;
    displayMessage: string;
  }>;
}

const APRIVA_PAYMENT = gql`
  mutation DigitalRefundRequest {
    data(body: $body)
      @rest(
        type: "Post"
        path: "commands/startMachineWithAnonStudentCard"
        method: "POST"
        bodyKey: "body"
      ) {
      name
      success
      data
    }
  }
`;

export default APRIVA_PAYMENT;
